import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useClient from 'api/client';
import getDatasetTable from 'api/DatasetTable/getDatasetTable';
import { useAlert } from 'components/message/AlertContext';

export default function useTables() {
    const params = useParams();
    const { openAlert } = useAlert();
    const client = useClient();
    const [loading, setLoading] = useState(true);
    const [datasetLabel, setDatasetLabel] = useState('');
    const [tableLabel, setTableLabel] = useState('');
    const [blockPreview, setBlockPreview] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            if (params.uri) {
                const response = await client.query(
                    getDatasetTable(params.uri),
                );
                if (!response.errors) {
                    setTableLabel(response.data.getDatasetTable.label);
                    setDatasetLabel(
                        response.data.getDatasetTable.dataset.label,
                    );
                    setBlockPreview(
                        response.data.getDatasetTable.dataset.environment
                            .blockpreview === 'All',
                    );
                } else {
                    setError(true);
                    openAlert({
                        message: `Failed to retrieve table ${response.errors[0].message}`,
                        severity: 'alert',
                    });
                }
            }
            setLoading(false);
        };

        if (client) {
            fetchData();
        }
    }, [client, params.uri]);

    return { tableLabel, datasetLabel, loading, error, blockPreview };
}
